export default __webpack_public_path__ + "static/media/flag-bonaire,-sint-eustatius-and-saba.9a65ab6d.svg";